import { PermissionName } from './user-permissions';

export function permission(permissionName: PermissionName | PermissionName[]) {
    return { permission: permissionName };
}